import { render } from "./BuyIns.vue?vue&type=template&id=2ac97786&scoped=true"
import script from "./BuyIns.vue?vue&type=script&lang=js"
export * from "./BuyIns.vue?vue&type=script&lang=js"

import "./BuyIns.vue?vue&type=style&index=0&id=2ac97786&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac97786"]])

export default __exports__